/**
 * @template T
 * @param {Array<import('react').MutableRefObject<T> | import('react').LegacyRef<T>>} refs
 * @returns {import('react').RefCallback<T>}
 */
const mergeRefs = refs => {
  return value => {
    refs.forEach(ref => {
      if (typeof ref === 'function') {
        ref(value)
      } else if (ref != null) {
        ref.current = value
      }
    })
  }
}

module.exports = mergeRefs
